export default "__VITE_ASSET__B3NoGYk9__"